import React, { Component } from 'react'
import { Grid, Icon, Form, Menu, Label, Tab, Image, Popup, Header, Input } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
import { Container } from 'react-smooth-dnd';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import convertIcon from '../../../../../helpers/convert-Icon';

import NoSearchFoundImage from '../../../../../images/grafix-banner/gfx-no-results.svg';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext(props.nameOfHelpText)
})

class ReferencesList extends Component {

    isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let author =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
          });
        if (author && author.length > 0) {
          return author.find((author) => author.email === loggdinUserId);
        }
        return null;
      };

       isContributor = () => {
        const loggdinUserId = this.props.user.email;
        let contributor =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "contributor";
          });
        if (contributor && contributor.length > 0) {
          return contributor.find((contributor) => contributor.email === loggdinUserId);
        }
        return null;
      };
      isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };

    removeReference(itemData, activityData) {
       
        let item = itemData && itemData.id && itemData.id._id ? itemData.id : itemData

        let message = <div className="confirmMessage">
            <h3>Delete Reference</h3>
            <label>{item.name}</label>
            <p>Are you sure that you wish to delete this reference?</p>
            <span >This action is not reversible</span>
        </div>

        toastr.confirm(message, {
            onOk: () => {
                var index = activityData.references.findIndex((element, i) => {
                    return element.id._id === item._id
                });
                activityData.removedRef = item._id;
                activityData.references.splice(index, 1)
                dispatch.createPack.editActivityAsync(activityData)
                //dispatch.createPack.removeReference(index);
            }
        });
    }



    render() {

        const { contentList, activity, type, selectedPracticeLibrary, currentOrganization } = this.props;


        let contentItem = contentList && contentList.id && contentList.id._id ? contentList.id : contentList

        return <div className="divBox display-flex-root" style={{height:"33px"}}>

            <div className="float-left" style={{ width: "calc(100% - 140px)" }}>
                <a target="_blank" rel="noopener noreferrer" href={contentList.id.contentpath && contentList.id.contentpath.indexOf('://') === -1 ? 'http://' + contentList.id.contentpath : contentList.id.contentpath}>
                    <Icon name={convertIcon(contentItem.type)} />
                </a>&nbsp; &nbsp;
                <EllipsisTooltip
                    className="float-left" style={{ width: "calc(100% - 40px)" }}
                    name={contentItem.name}
                    deprecated={contentItem.deleted}
                    // name={contentItem.deleted ? `${contentItem.name} (deprecated)` : contentItem.name}
                />
            </div>

            <div className="float-right text-right" style={{ width: "140px" }}>
                <span style={{ color: '#bababc' }} > {contentItem.scope ? contentItem.scope === "Private" ? "Workspace" : contentItem.scope : contentItem.scope === "Private" ? "Workspace" : contentItem.scope} </span> &nbsp; &nbsp;
                {contentItem.createdBy && contentItem.createdBy.profilePic ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={
                            <Image avatar src={contentItem.createdBy.profilePic} />
                        }
                        position="top right"
                        content={<span>{contentItem.createdBy.firstName} {contentItem.createdBy.lastName}</span>}
                    />
                    : null}
                
                {
                  (this.props.selectedPracticeLibrary) && (this.props.selectedPracticeLibrary.status === 0 || 
                    (this.props.selectedPracticeLibrary.status === 4 ) && (this.isContributor() || this.isWorkspaceOwner())) // (selectedPracticeLibrary.status === 0) || (selectedPracticeLibrary.status === 4)
                            // (selectedPracticeLibrary.status === 0) || (selectedPracticeLibrary.status === 4)
                            ?
                                type === "phase" || type === "stage" ?
                                    null : <Icon
                                        className="close-icon"
                                        name="close"
                                        onClick={() => this.removeReference(contentItem, activity)} />
                                : null
                }

                    &nbsp; &nbsp;
                </div>
        </div>;
    }
}



class CommunityActivityResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            name: null
        }
    }

    isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let author =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
          });
        if (author && author.length > 0) {
          return author.find((author) => author.email === loggdinUserId);
        }
        return null;
      };

       isContributor = () => {
        const loggdinUserId = this.props.user.email;
        let contributor =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "contributor";
          });
        if (contributor && contributor.length > 0) {
          return contributor.find((contributor) => contributor.email === loggdinUserId);
        }
        return null;
      };
      isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };



    onDragEnd = (result) => {
        this.setState({ name: null })
        // const { handleDragEnd, boardId } = this.props;
        const { addedIndex, payload } = result;
        if (addedIndex != null) {
            if (payload.draggableType === "content") {
                payload.isRequired = true;
                let checkName = this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.references && this.props.selectedPracticeFlowActivity.references.filter((item) => { return item.id && item.id._id === payload.id })

                if (checkName && checkName.length > 0) {
                    toastr.error('Message', 'Content already present.')
                } else {
                    (this.props.selectedPracticeFlowActivity.references).push(payload)
                    dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
                    // dispatch.createPack.setreferenceContentDataAsync([payload]);
                }
            }
        }
    }

    shouldAcceptDrop = sourceContainerOptions => {
        const accessDrop = sourceContainerOptions.groupName === 'Content'
        return accessDrop
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex })
        this.setState({ name: '' })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedPracticeFlowActivity) {
            if (this.props.selectedPracticeFlowActivity.isLeafNode) {
                this.setState({ activityName: newProps.selectedPracticeFlowActivity.name })
            }
            if (this.props.selectedPracticeFlowActivity.parentActivity) {
                this.setState({ phaseName: this.props.selectedPracticeFlowActivity.parentActivity.name })
                this.setState({ stageName: this.props.selectedPracticeFlowActivity.name })
                if (this.props.selectedPracticeFlowActivity.parentActivity.parentActivity) {
                    this.setState({ phaseName: this.props.selectedPracticeFlowActivity.parentActivity.parentActivity.name })
                    this.setState({ stageName: this.props.selectedPracticeFlowActivity.parentActivity.name })
                }
            }
        }

        if (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.parentActivity !== newProps.parentActivity) {
            this.setState({ name: "" })
        }
    }

    render() {
        
        const { selectedPracticeFlowActivity, selectedPracticeLibrary } = this.props
        const { activeIndex } = this.state

        let isAuthorized = false;
        selectedPracticeLibrary && selectedPracticeLibrary.participants && selectedPracticeLibrary.participants.map(participant => {
            if (this.props.user._id === participant.accountUserId && (participant.role === 'author' || participant.role === 'contributor')) {
                isAuthorized = true;
            }
        });


        let NoReferencesComponent = <div fluid className="w_100 " style={{ padding: "10px 0" }}>
            <Image src={NoSearchFoundImage} size='small' centered={true} />
            <Header as='h3' icon textAlign='center'>
                <Header.Content >
                    Nothing to show!
                <br />  <br />
                </Header.Content>
            </Header>
        </div>

        // Phase
        // If Parent Node

        // Stage
        // If parent Node and isParent Activity

        // Activity
        // Is Leaf Node


        //Phase
        let isParentActivity = selectedPracticeFlowActivity && selectedPracticeFlowActivity.parentActivity
        let phaseRefCheck;
        if (isParentActivity && isParentActivity.parentActivity) {
            phaseRefCheck = isParentActivity &&
                isParentActivity.parentActivity;
        } else {
            phaseRefCheck = isParentActivity
        }

        let PhaseComponent = phaseRefCheck && phaseRefCheck.references && phaseRefCheck.references.length !== 0 ?
            phaseRefCheck.references
                .filter((f, i) => { return this.state.name && activeIndex === 2 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList key={index} selectedPracticeLibrary={selectedPracticeLibrary} type="phase" contentList={reference} activity={phaseRefCheck} currentOrganization={this.props.currentOrganization} user={this.props.user} />
                })
            : null


        //Stage
        let StageRefCheck;
        if (isParentActivity && isParentActivity.parentActivity) {
            StageRefCheck = isParentActivity
        } else {
            StageRefCheck = null
        }

        let StageComponent = StageRefCheck && StageRefCheck.references && StageRefCheck.references.length !== 0 ?
            StageRefCheck.references
                .filter((f, i) => { return this.state.name && activeIndex === 1 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList key={index} selectedPracticeLibrary={selectedPracticeLibrary} type="stage" contentList={reference} activity={StageRefCheck} currentOrganization={this.props.currentOrganization} user={this.props.user} />
                }) : null


        //Activity
        let ActivityComponent = selectedPracticeFlowActivity.references &&
            selectedPracticeFlowActivity.references.length !== 0 ?
            selectedPracticeFlowActivity.references
                .filter((f, i) => { return this.state.name && activeIndex === 0 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList key={index} selectedPracticeLibrary={selectedPracticeLibrary} type="activity" contentList={reference} activity={selectedPracticeFlowActivity} currentOrganization={this.props.currentOrganization} user={this.props.user} />
                }) : null


        let searchByName = <Input
            className="w_100"
            placeholder='Search by Content name'
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })} />

        let phase = {
            menuItem: <Menu.Item key='Phase'>
                {this.state.phaseName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>Phase</span>}
                        content={this.state.phaseName}
                    /> : "Phase"} <Label>{PhaseComponent ? PhaseComponent.length : 0}</Label>
            </Menu.Item>, render: () => <div>
                {searchByName}
                {PhaseComponent && PhaseComponent.length !== 0 ? PhaseComponent : NoReferencesComponent}
            </div>
        }

        let stage = {
            menuItem: isParentActivity && isParentActivity.parentActivity && isParentActivity.parentActivity._id ? <Menu.Item key='Stage'>
                {this.state.stageName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>Stage</span>}
                        content={this.state.stageName}
                    /> : "Stage"} <Label>{StageComponent ? StageComponent.length : 0}</Label>
            </Menu.Item> : null, render: () => <div>
                {searchByName}
                {StageComponent && StageComponent.length !== 0 ? StageComponent : NoReferencesComponent}
            </div>
        }

        let act = {
            menuItem: <Menu.Item key='Activity' >
                {this.state.activityName || this.state.stageName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>{selectedPracticeFlowActivity.isParentNode ? "Stage" : "Activity"}</span>}
                        content={this.state.activityName ? this.state.activityName : this.state.stageName}
                    /> : selectedPracticeFlowActivity.isParentNode ? "Stage" : "Activity"}

                <Label>{ActivityComponent ? ActivityComponent.length : 0}</Label>
            </Menu.Item>, render: () => <div>
                {dropingContentComponent}
                {searchByName}
                {ActivityComponent && ActivityComponent.length !== 0 ? ActivityComponent : NoReferencesComponent}
            </div>
        }

       let dropingContentComponent = (this.props.selectedPracticeLibrary) && 
            (this.props.selectedPracticeLibrary.status === 0 || 
            (this.props.selectedPracticeLibrary.status === 4 ) && (this.isContributor() || this.isWorkspaceOwner())) ? (
            <Container 
                style={{
                    margin: '0 0 10px 0',
                    width: '100%', 
                    border: '1px dashed #333',
                    padding: '15px 0'
                }}
                groupName="Content"
                behaviour="copy"
                getChildPayload={i => this.state.items[i]}
                onDrop={e => this.onDragEnd(e)}
                shouldAcceptDrop={this.shouldAcceptDrop}
            >
                <center> Drop content here. </center>
            </Container>
        ) : null;

        const panes = []

        if (selectedPracticeFlowActivity.isLeafNode) {
            panes.push(act)
            panes.push(stage)
            panes.push(phase)
        } else if (selectedPracticeFlowActivity.isParentNode) {
            panes.push(act)
            panes.push(phase)
        }

        let showTabs = selectedPracticeFlowActivity.isLeafNode ||
            (selectedPracticeFlowActivity.isParentNode && isParentActivity)



        return (
            <Form className="referenceContainer" >
                {showTabs ? null :
                    <React.Fragment>
                        {dropingContentComponent}
                        {searchByName}
                        {this.props.selectedPracticeFlowActivity.references <= 0 ? NoReferencesComponent :''}    
                    </React.Fragment>}
                {showTabs ?
                    <Tab
                        style={{ padding: 0 , overflow:"auto" }}
                        menu={{ secondary: true, pointing: true }}
                        panes={panes}
                        activeIndex={activeIndex}
                        onTabChange={this.handleTabChange}
                        className={isParentActivity && isParentActivity.parentActivity && isParentActivity.parentActivity._id ? "three-block" : "two-block"} /> :
                    ActivityComponent}
            </Form >
        )
    }
}

export default CommunityActivityResourcePaneForm

